<template>
  <div>
    <div v-if="balanceData">
      <el-row>
        <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              v-if="balanceData.monthly && balanceData.monthly.last_state"
            >
              <div class="balance-number">
                {{ numberFormat(balanceData.monthly.last_state.balance) }}
              </div>
              <div class="balance-text">Monthly Contract Balance</div>
            </el-col>
          <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              v-if="balanceData.compliance && balanceData.compliance.last_state"
            >
              <div class="balance-number">
                {{ numberFormat(balanceData.compliance.last_state.balance) }}
              </div>
              <div class="balance-text">Compliance Contract Balance</div>
            </el-col>
      </el-row>
    </div>
  </div>

</template>

<script>
import { getContractBalance } from "@/api/customer";
import { currencyFormat, dateFormat } from "@/utils";
export default {
  name: "ContractBalance",
  props: {
    customerUID: String,
    bankholderID: String
  },
  data() {
    return {
      loading: false,
      balanceData: null,
    };
  },

  methods: {
    numberFormat(value) {
      return currencyFormat(Number(value), '');
    },
    dateFormat(value) {
      return dateFormat(value, 'DD/MM/YYYY HH:mm:ss');
    },
    getBalance() {
      this.loading = true;
      this.balanceData = null;
      getContractBalance(this.customerUID, this.bankholderID).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.balanceData = data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },

  },
  mounted() {
    this.getBalance();
  }
};
</script>

<style lang="scss" scoped></style>